import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Theme } from '@routific/hive';
import { COLUMN_WIDTHS } from './DriverOption/StyledCols';

const pulse = keyframes`
  0%, 100% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
`;

const SkeletonEl = styled.div<{ $w: number; $h: number; $round?: boolean }>`
  width: ${({ $w }) => $w}px;
  height: ${({ $h }) => $h}px;
  border-radius: ${({ $round }) => ($round ? '50%' : '6px')};
  background-color: ${Theme.Colors.gray3};
  animation: ${pulse} 1.5s ease-in-out infinite;
  flex-shrink: 0;
`;

const RowContainer = styled.div`
  display: flex;
  align-items: center;
  padding: ${Theme.Spacing.smSpacing} ${Theme.Spacing.mdSpacing};
`;

const NameSection = styled.div`
  display: flex;
  align-items: center;
  gap: ${Theme.Spacing.xsSpacing};
  width: ${COLUMN_WIDTHS.name};
  flex-shrink: 0;
`;

const RoutesSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-left: ${Theme.Spacing.lgSpacing};
  width: ${COLUMN_WIDTHS.routes};
`;

const FamiliaritySection = styled.div`
  display: flex;
  align-items: center;
  margin-left: ${Theme.Spacing.lgSpacing};
  gap: 1px;
  width: ${COLUMN_WIDTHS.familiarity};
`;

const SpeedSection = styled.div`
  display: flex;
  align-items: center;
  margin-left: ${Theme.Spacing.mdSpacing};
  min-width: ${COLUMN_WIDTHS.speed};
`;

const SkeletonRow: React.FC = () => (
  <RowContainer>
    <NameSection>
      <SkeletonEl $w={24} $h={24} $round />
      <SkeletonEl $w={120} $h={12} />
    </NameSection>
    <RoutesSection>
      <SkeletonEl $w={8} $h={8} $round />
    </RoutesSection>
    <FamiliaritySection>
      <SkeletonEl $w={21} $h={8} />
      <SkeletonEl $w={21} $h={8} />
      <SkeletonEl $w={21} $h={8} />
    </FamiliaritySection>
    <SpeedSection>
      <SkeletonEl $w={44} $h={12} />
    </SpeedSection>
  </RowContainer>
);

const SkeletonRows: React.FC = () => (
  <>
    {Array.from({ length: 6 }).map((_, i) => (
      <SkeletonRow key={`sk-${i}`} />
    ))}
  </>
);

export default SkeletonRows;
